/**
 * Save and restore selected items in the ListView. Supports single or multiple selection.
 *
 * Save
 * -Captures the currently selected items
 *
 * Restore
 * -Selects saved items
 */


/**
 * Create a saved selection. Must call save() manually.
 * @param listview listview to operate on
 * @constructor
 */
var Selection = function(grid) {
    this.grid = grid;
    this.ids = new Set();
    this.uids = new Set();
};

/**
 * Save the current selections.
 */
Selection.prototype.save = function() {
    this.ids.clear();
    this.uids.clear();
    this.skip = false;
    var item;
    var selected = this.grid.select();
    for (var i = 0; i < selected.length; i++) {
        item = this.grid.dataItem(selected[i]);
        if (item) {
            this.ids.add(item.get(item.idField));
            this.uids.add(item.uid);
        }
    }
    if (this.grid.element.find("li").length == 0) {
        this.skip = true;
    }
};

/**
 * Restore the saved selections.
 */
Selection.prototype.restore = function() {
    if (this.grid.select().length) {
        return;
    }
    var rows = this.grid.element.find("li[data-uid]");
    var item;
    var toSelect = [];
    for (var i = 0; i < rows.length; i++) {
        item = this.grid.dataItem(rows[i]);
        if (item && ((item.idField && item.get(item.idField) && this.ids.has(item.get(item.idField))) || this.uids.has(item.uid))) {
            toSelect.push(rows[i]);
        }
    }
    if (toSelect.length > 0) {
        this.grid.select(toSelect);
    }
    // no need to clear selection, because we didn't even get this far if there was already a selection.
};

export default Selection;
